(function() { window.GUID_4268779f_d4d6_44ba_b4ec_c4499bc4b2b6 = { getGuid: function() { return "4268779f-d4d6-44ba-b4ec-c4499bc4b2b6"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Popover {
            constructor(referenceElement, url, data, withOverlay = true, allowClickOnTarget = false, freezeUI = false, content = null) {
                this.referenceElement = referenceElement;
                this.url = url;
                this.data = data;
                this.withOverlay = withOverlay;
                this.allowClickOnTarget = allowClickOnTarget;
                this.freezeUI = freezeUI;
                this.content = content;
                this.scrollToReferenceElement = false;
                this.cleanupAutoUpdate = null;
                if (this.freezeUI) {
                    this.withOverlay = true;
                    this.scrollToReferenceElement = true;
                }
                this.popoverElement = document.createElement("div");
                this.popoverElement.className = "popover";
                this.popoverHeaderElement = document.createElement("div");
                this.popoverHeaderElement.className = "popover-header";
                this.popoverHeaderElement.innerHTML = `<div class="ic-cs-times ico-div"></div>`;
                this.arrowElement = document.createElement("div");
                this.arrowElement.className = "popover-arrow";
                this.popoverElement.prepend(this.popoverHeaderElement);
                this.popoverElement.appendChild(this.arrowElement);
                document.body.appendChild(this.popoverElement);
                if (this.withOverlay) {
                    this.overlayElement = document.createElement("div");
                    this.overlayElement.className = "popover-overlay";
                    this.overlayElement.addEventListener("click", () => this.hide());
                    this.referenceOverlayElement = document.createElement("div");
                    this.referenceOverlayElement.className = "popover-reference-overlay";
                    this.referenceOverlayElement.addEventListener("click", () => {
                        this.hide();
                        if (this.allowClickOnTarget) {
                            this.referenceElement.click();
                        }
                    });
                }
                this.popoverElement.addEventListener("click", () => this.hide());
            }
            getContent() {
                return new Promise((resolve, reject) => {
                    if (this.content) {
                        return resolve(this.content);
                    }
                    CS.Ajax.Get(this.url, this.data, (response) => {
                        return resolve(response);
                    });
                });
            }
            show() {
                return new Promise((resolve, reject) => {
                    try {
                        if (this.scrollToReferenceElement) {
                            CS.DOM.$body.addClass("overflow--hidden");
                        }
                        if (window["FloatingUIDOM"]) {
                            this.getContent().then((content) => {
                                this.popoverElement.innerHTML = content;
                                this.popoverElement.appendChild(this.arrowElement);
                                this.popoverElement.prepend(this.popoverHeaderElement);
                                this.cleanupAutoUpdate = window["FloatingUIDOM"].autoUpdate(this.referenceElement, this.popoverElement, () => {
                                    window["FloatingUIDOM"]
                                        .computePosition(this.referenceElement, this.popoverElement, {
                                        placement: "top",
                                        middleware: [
                                            window["FloatingUIDOM"].offset(32),
                                            window["FloatingUIDOM"].flip({
                                                padding: {
                                                    top: CS.Views.MasterPage.TopHeight,
                                                    bottom: CS.Views.MasterPage.BottomHeight,
                                                },
                                            }),
                                            window["FloatingUIDOM"].arrow({
                                                element: this.arrowElement,
                                            }),
                                            window["FloatingUIDOM"].hide({
                                                padding: {
                                                    top: CS.Views.MasterPage.TopHeight,
                                                    bottom: CS.Views.MasterPage.BottomHeight,
                                                },
                                            }),
                                        ],
                                    })
                                        .then(({ x, y, middlewareData, placement }) => {
                                        Object.assign(this.popoverElement.style, {
                                            left: `${x}px`,
                                            top: `${y}px`,
                                            position: "absolute",
                                        });
                                        if (this.withOverlay) {
                                            let top = y;
                                            if (placement === "top") {
                                                top += 32 + this.popoverElement.offsetHeight;
                                            }
                                            else {
                                                top -= 32 + this.referenceElement.offsetHeight;
                                            }
                                            const borderRadius = $(this.referenceElement).css("border-radius");
                                            Object.assign(this.referenceOverlayElement.style, {
                                                width: `${this.referenceElement.offsetWidth}px`,
                                                height: `${this.referenceElement.offsetHeight}px`,
                                                top: `${top}px`,
                                                left: `${this.referenceElement.getBoundingClientRect().left}px`,
                                                "border-radius": borderRadius,
                                            });
                                        }
                                        if (middlewareData.arrow) {
                                            const { x: arrowX, y: arrowY } = middlewareData.arrow;
                                            if (placement === "top") {
                                                Object.assign(this.arrowElement.style, {
                                                    left: arrowX != null ? `${arrowX}px` : "",
                                                    top: "",
                                                    bottom: "-24px",
                                                });
                                                this.arrowElement.classList.remove("triangle-top");
                                                this.arrowElement.classList.add("triangle-bottom");
                                            }
                                            else {
                                                Object.assign(this.arrowElement.style, {
                                                    left: arrowX != null ? `${arrowX}px` : "",
                                                    top: "-24px",
                                                    bottom: "",
                                                });
                                                this.arrowElement.classList.remove("triangle-bottom");
                                                this.arrowElement.classList.add("triangle-top");
                                            }
                                        }
                                        if (middlewareData.hide) {
                                            Object.assign(this.popoverElement.style, {
                                                visibility: middlewareData.hide.referenceHidden
                                                    ? "hidden"
                                                    : "visible",
                                            });
                                            if (this.withOverlay) {
                                                Object.assign(this.overlayElement.style, {
                                                    display: middlewareData.hide.referenceHidden
                                                        ? "none"
                                                        : "block",
                                                    "pointer-events": middlewareData.hide
                                                        .referenceHidden
                                                        ? "none"
                                                        : "auto",
                                                });
                                                Object.assign(this.referenceOverlayElement.style, middlewareData.hide.referenceHidden
                                                    ? {
                                                        display: "none",
                                                        "pointer-events": "none",
                                                    }
                                                    : {
                                                        display: "block",
                                                        "pointer-events": "auto",
                                                    });
                                            }
                                        }
                                    });
                                });
                                this.popoverElement.style.display = "block";
                                if (this.withOverlay) {
                                    document.body.appendChild(this.overlayElement);
                                    document.body.appendChild(this.referenceOverlayElement);
                                }
                                setTimeout(() => {
                                    this.referenceOverlayElement.style.opacity = "1";
                                    this.popoverElement.style.opacity = "1";
                                }, 100);
                                return resolve();
                            });
                        }
                        else {
                            throw new Error("FloatingUIDOM is not defined");
                        }
                    }
                    catch (error) {
                        if (this.scrollToReferenceElement) {
                            CS.DOM.$body.removeClass("overflow--hidden");
                        }
                        return reject(error);
                    }
                });
            }
            hide() {
                this.popoverElement.style.display = "none";
                if (this.scrollToReferenceElement) {
                    CS.DOM.$body.removeClass("overflow--hidden");
                }
                if (this.cleanupAutoUpdate) {
                    this.cleanupAutoUpdate();
                    this.cleanupAutoUpdate = null;
                }
                this.popoverElement.style.transition = "opacity 0.2s";
                this.popoverElement.style.opacity = "0";
                CS.Lag("popover", 200, () => {
                    this.popoverElement.remove();
                    if (this.onHide) {
                        this.onHide();
                    }
                });
                if (this.withOverlay) {
                    if (this.overlayElement && this.overlayElement.parentElement) {
                        this.overlayElement.style.transition = "opacity 0.2s";
                        this.overlayElement.style.opacity = "0";
                        CS.Lag("popover-overlay", 200, () => {
                            this.overlayElement.parentElement.removeChild(this.overlayElement);
                        });
                    }
                    if (this.referenceOverlayElement &&
                        this.referenceOverlayElement.parentElement) {
                        this.referenceOverlayElement.style.transition = "opacity 0.2s";
                        this.referenceOverlayElement.style.opacity = "0";
                        CS.Lag("popover-reference-overlay", 200, () => {
                            this.referenceOverlayElement.parentElement.removeChild(this.referenceOverlayElement);
                        });
                    }
                }
            }
        }
        Controls.Popover = Popover;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=Popover.js.map
